import React, { memo } from 'react'
import { useHistoryNew } from '@utils'
import './index.scss'

interface ILoginGuideProps {
  isLogin?: boolean;
}

const LoginGuide: React.FC<ILoginGuideProps> = ({ isLogin }) => {
  const history = useHistoryNew()
  if (isLogin || window.MEMBERISBUSY) {
    return null
  }
  return (
    <div className='login-guide-wrapper'>
      <div className='login-guide-info'>
        <i className='iconfont icon-qiaopi'></i>
        <span>{i18n.t('checkout.youAreaGuest')}</span>
      </div>
      <a className='link' data-cypid='loginGuidToLogin' onClick={() => history.push('/login')}>
        <span>
          {i18n.t('common.loginIn')}/{i18n.t('common.register')}
        </span>
      </a>
    </div>
  )
}

export default memo(LoginGuide)
